import { Component, OnInit } from '@angular/core'
import { SelectWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-select-widget',
  templateUrl: './select-widget.component.html',
  styleUrls: ['./select-widget.component.scss'],
})
export class SelectWidgetComponent extends SelectWidget {}
